import { Component, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { FormV2ServiceService } from '../form-v2/form-v2-service.service';

@Component({
  selector: 'app-tests',
  templateUrl: './tests.component.html',
  styleUrls: ['./tests.component.scss']
})
export class TestsComponent implements OnInit {

  



systems = ['ma', 'mad', 'pg', 'mp', 'mpd', 'fs', 'fsd', 'fr', 'frd', 'mv', 'mvd'];
  form!: FormGroup;

  constructor(private fb: FormBuilder, private formService: FormV2ServiceService) {}

  ngOnInit(): void {
    this.form = this.fb.group({
      systems: this.fb.array(this.systems.map(() => false)),

      dateFromEnabled: [false],
      dateFrom: [{ value: null, disabled: true }],

      dateToEnabled: [false],
      dateTo: [{ value: null, disabled: true }],

      maxOrdersEnabled: [false],
      maxOrders: [{ value: null, disabled: true }, Validators.min(1)],

      keyValuesEnabled: [false],
      keyValues: this.fb.array([])
    });

    this.setupToggles();
  }

  /* ---------- getters ---------- */

  get systemsArray(): FormArray {
    return this.form.get('systems') as FormArray;
  }

  get keyValues(): FormArray {
    return this.form.get('keyValues') as FormArray;
  }

  /* ---------- toggles ---------- */

  setupToggles(): void {
    this.toggleOnChange('dateFromEnabled', 'dateFrom');
    this.toggleOnChange('dateToEnabled', 'dateTo');
    this.toggleOnChange('maxOrdersEnabled', 'maxOrders');

    this.form.get('keyValuesEnabled')?.valueChanges.subscribe(enabled => {
      if (enabled && this.keyValues.length === 0) {
        this.addKeyValue();
      }
      if (!enabled) {
        this.keyValues.clear();
      }
    });
  }

  private toggleOnChange(toggle: string, field: string): void {
    this.form.get(toggle)?.valueChanges.subscribe(enabled => {
      enabled ? this.form.get(field)?.enable() : this.form.get(field)?.disable();
    });
  }

  /* ---------- key=value ---------- */

  addKeyValue(): void {
    this.keyValues.push(
      this.fb.group({
        key: ['', Validators.required],
        value: ['', Validators.required]
      })
    );
  }

  removeKeyValue(index: number): void {
    this.keyValues.removeAt(index);
  }

  /* ---------- submit ---------- */

  submit(): void {
    const selectedSystems = this.systems
      .filter((_, i) => this.systemsArray.value[i]);

    const payload = {
      systems: selectedSystems,
      dateFrom: this.form.value.dateFromEnabled ? this.form.value.dateFrom : null,
      dateTo: this.form.value.dateToEnabled ? this.form.value.dateTo : null,
      maxOrders: this.form.value.maxOrdersEnabled ? this.form.value.maxOrders : null,
      keyValues: this.form.value.keyValuesEnabled
        ? this.form.value.keyValues
        : []
    };

    // console.log('Payload:', payload);

    this.formService.GetOrderList(payload).
    subscribe((data) => {
      // console.log("ret", data);
    });
  }




}
